export default __webpack_public_path__ + "static/media/trash.2cb1d613.svg";